import Container from 'react-bootstrap/Container';

export default function Footer() {
  return (
    <Container as="footer">
      <small className="text-center d-block py-2 py-md-3 text-secondary">Consulcesi SA | Via G. Motta 6, 6828 Balerna CHE | 259458377 | +41 916952060 | PEC: consulcesisa@legalmail.it | Ufficio Stampa 06/45218235 - 328/4812859</small>
    </Container>
  );
}